import { useState } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

export default function NavBar() {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [expanded, setExpanded] = useState(false);

  const navigate = useNavigate();

  const handleMouseEnter = (dropdown) => {
    setOpenDropdown(dropdown);
  };

  const handleMouseLeave = () => {
    setOpenDropdown(null);
  };
  
  const scrollToSection = (id, event) => {
    event.preventDefault(); // Prevent default jump to top
  
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  
    // If you want to update the URL without reloading
    window.history.pushState(null, null, `/#${id}`);
  };

  // When clicking Home, just navigate to `/`
const handleHomeClick = () => {
  navigate("/"); // Goes to home without scrolling
};
  const handleNavClick = (id, e) => {
    e.preventDefault();
    
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } }); // Pass section to scroll after navigation
    } else {
      scrollToSection(id,e );
    }
  
    handleMouseLeave(); // Close dropdown after clicking
    setExpanded(false);
  };

  return (
    <Navbar expand="lg" bg="light" variant="light" className="shadow-sm w-100" expanded={expanded} onToggle={(isOpen) => setExpanded(isOpen)}  onMouseLeave={(e)=>{handleMouseEnter("")}}>
      <Container fluid className="ps-4" onMouseLeave={(e)=>{handleMouseLeave}}>
        {/* Logo Section */}
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center" onMouseEnter={() => handleMouseEnter("")}>
          <img src="/logo-new.png" alt="Blueberry Infratech Logo" width={50} height={50} className="me-2" />
          <span className="fw-bold fs-3 text-primary">Blueberry Infratech</span>
        </Navbar.Brand>

        {/* Mobile Toggle Button */}
        <Navbar.Toggle  onClick={() => setExpanded(!expanded)}  aria-controls="navbar-nav" />

        {/* Navbar Links */}
        <Navbar.Collapse id="navbar-nav" onMouseEnter={() => handleMouseEnter("")}>
          <Nav className="ms-auto custom-gap" onMouseEnter={() => handleMouseEnter("")}  >
            {/* Home Dropdown */}
            <NavDropdown
              title="Home"
              id="home-dropdown"
              show={openDropdown === "home"}
              onMouseEnter={() => handleMouseEnter("home")}
              onClick={handleHomeClick}
            >
              <NavDropdown.Item as={Link} to="/" onClick={(e) => handleNavClick("about-us", e)}   onMouseEnter={() => handleMouseEnter("home")}>About Us</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={(e) => handleNavClick("vision", e)} onMouseEnter={() => handleMouseEnter("home")}>Vision</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={(e) => handleNavClick("boardofdirectors", e)} onMouseEnter={() => handleMouseEnter("home")}>Board of Directors</NavDropdown.Item>
            </NavDropdown>

            {/* Sectors Dropdown */}
            <NavDropdown
              title="Sectors"
              id="sectors-dropdown"
              show={openDropdown === "sectors"}
              onMouseEnter={() => handleMouseEnter("sectors")}
            >
              <NavDropdown.Item as={Link} to="/sectors/irrigation" onClick ={()=> {handleMouseEnter("");setExpanded(false)}} onMouseEnter={() => handleMouseEnter("sectors")}>Irrigation</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/sectors/power" onClick ={()=> {handleMouseEnter("");setExpanded(false)}} onMouseEnter={() => handleMouseEnter("sectors")}>Power</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/sectors/roadways" onClick ={()=> {handleMouseEnter("");setExpanded(false)}} onMouseEnter={() => handleMouseEnter("sectors")}>Roadways</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/sectors/railways"  onClick ={()=> {handleMouseEnter("");setExpanded(false)}} onMouseEnter={() => handleMouseEnter("sectors")}>Railways</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/sectors/buildings" onClick ={()=> {handleMouseEnter("");setExpanded(false)}} onMouseEnter={() => handleMouseEnter("sectors")}>Buildings</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/sectors/financial" onClick ={()=> {handleMouseEnter("");setExpanded(false)}} onMouseEnter={() => handleMouseEnter("sectors")}>Financial Services</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/sectors/technical" onClick ={()=> {handleMouseEnter("");setExpanded(false)}} onMouseEnter={() => handleMouseEnter("sectors")}>Technical Services</NavDropdown.Item>
            </NavDropdown>

            {/* Projects Dropdown */}
            <NavDropdown
              title="Projects"
              id="projects-dropdown"
              show={openDropdown === "projects"}
              onMouseEnter={() => handleMouseEnter("projects")}
            >
              <NavDropdown.Item as={Link} to="/projects/ongoing"  onClick ={()=> {handleMouseEnter("");setExpanded(false)}} onMouseEnter={() => handleMouseEnter("projects")}>On-Going</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/projects/completed"  onClick ={()=> {handleMouseEnter("");setExpanded(false)}} onMouseEnter={() => handleMouseEnter("projects")}>Completed</NavDropdown.Item>
            </NavDropdown>

            {/* Media Dropdown */}
            <NavDropdown
              title="Media"
              id="media-dropdown"
              show={openDropdown === "media"}
              onMouseEnter={() => handleMouseEnter("media")}
            >
              <NavDropdown.Item as={Link} to="/media/news"  onClick ={()=> {handleMouseEnter("");setExpanded(false)}} onMouseEnter={() => handleMouseEnter("media")}>News</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/media/gallery"  onClick ={()=> {handleMouseEnter("");setExpanded(false)}} onMouseEnter={() => handleMouseEnter("media")}>Gallery</NavDropdown.Item>
            </NavDropdown>

            {/* Careers Dropdown */}
            <NavDropdown
              title="Careers"
              id="careers-dropdown"
              show={openDropdown === "careers"}
              onMouseEnter={() => handleMouseEnter("careers")}
             
            >
              <NavDropdown.Item as={Link} to="/careers/jobs"  onClick ={()=> {handleMouseEnter("");setExpanded(false)}} onMouseEnter={() => handleMouseEnter("careers")}>Job Openings</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/careers/internships"  onClick ={()=> {handleMouseEnter("");setExpanded(false)}} onMouseEnter={() => handleMouseEnter("careers")}>Internships</NavDropdown.Item>
            </NavDropdown>

            {/* Contact Us */}
            <Nav.Link as={Link} to="/contact" onMouseEnter={() => {handleMouseEnter("");setExpanded(false)}} className="fw-thin" >
              Contact Us
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
